import { Statuses } from '../constants/statuses';
import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const updateDocument = (docId, data) => putJson(`/insurance-documents/${docId}`, data);

export const updateDocumentName = (docId, data) => putJson(`/insurance-documents/${docId}/names`, data);

export const reactivateDocument = docId => putJson(`/insurance-documents/${docId}`, { status: Statuses.Active });

export const archiveDocument = docId => putJson(`/insurance-documents/${docId}`, { status: Statuses.Archived });

export const deleteDocument = docId => putJson(`/insurance-documents/${docId}`, { status: Statuses.Deleted });

export const updateAssociatedPolicies = (docId, policyIds) => putJson(`/insurance-documents/${docId}/policies`, { policies: policyIds });

export const getDocumentExpirations = docId => getJson(`/insurance-documents/${docId}/expirations`);

export const createDocumentExpiration = (docId, data) => postJson(`/insurance-documents/${docId}/expirations`, data);

export const updateDocumentExpiration = (id, data) => putJson(`/insurance-document-expirations/${id}`, data);

export const deleteDocumentExpiration = id => deleteJson(`/insurance-document-expirations/${id}`);

export const getGptRequest = gptRequestId => getJson(`/gpt-requests/${gptRequestId}`);

export const extractDocumentExpirations = documentIds => postJson('/gpt-requests/document-expirations', { document_ids: documentIds });

export const createDocumentExpirations = (docId, expirations) => postJson(`/insurance-documents/${docId}/expirations/bulk`, { expirations });

export const confirmExtractedExpirations = (gptRequestId, expirations) => postJson(`/gpt-requests/${gptRequestId}/confirm`, { expirations });
